///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.three_pm_import = abcsetup.three_pm_import || {};
abcsetup.three_pm_import.workflow = abcsetup.three_pm_import.workflow || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.task = null;


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.three_pm_import.workflow = {
    init: function () {
        require('jscroll');
        $("html, body").scrollTop(0);
        abcsetup.setTitle('Review 3rd Party Marketplace Items');

        // Reject button clicked
        $('#reject-btn').on('click', function () {
            abcsetup.three_pm_import.workflow._rejectAll();
        });

        // Approve button clicked
        $(document).on('click', 'button.approve-item', function (event) {
            var item = $(this).closest('.card-header').data('item');
            abcsetup.three_pm_import.workflow._approveItem(item,event);
            return false;
        });

        // Reject button clicked
        $(document).on('click', 'button.reject-item', function (event) {
            var item = $(this).closest('.card-header').data('item');
            abcsetup.three_pm_import.workflow._rejectItem(item,event);
            return false;
        });

        // Submit button clicked
        $(document).on('click', 'button.submit-item', function (event) {
            var item = $(this).closest('.card-header').data('item');
            abcsetup.three_pm_import.workflow._submitItem(item,event);
            return false;
        });

        // Remove button clicked
        $(document).on('click', 'button.remove-item', function (event) {
            var item = $(this).closest('.card-header').data('item');
            abcsetup.three_pm_import.workflow._removeItem(item,event);
            return false;
        });

         // Accordion open/closed
         $(document).on('show.bs.collapse', '.collapse', function() {
            console.log('show');
            $('#item-accordion').data('showing', true).data('item', $(this).attr('id'));
            $(this).parent().find(".fa").toggleClass("down");

        }).on('hide.bs.collapse', '.collapse', function(event) {
            console.log('hide');
            // Prevent other items from collapsing when opening a new one
            if ($('#item-accordion').data('showing') && $('#item-accordion').data('item') != $(this).attr('id')) {
                event.preventDefault();
                return;
            }

            $('#item-accordion').data('showing', false);
            $(this).parent().find(".fa").toggleClass("down");
        });

        $('ul.pagination').hide();
        $(function() {
            $('.scrolling-pagination').jscroll({
                autoTrigger: true,
                padding: 0,
                nextSelector: '.pagination li.active + li a',
                contentSelector: 'div.scrolling-pagination',
                callback: function() {
                    $('ul.pagination').remove();
                }
            });
        });
        // // Export button clicked
        // $('button.export').on('click', function (event) {
        //     abcsetup.three_pm_import.workflow._export(event);
        //     return false;
        // });
    },

    /**
     * Bind the reject dropdown events
     */
    _bindRejectDropdown: function () {
        $(document).on('click', '.dropdown-menu', function (event) {
            event.stopPropagation();
            return false;
        });
        $(document).on('click', '.dropdown-menu.reject', function (event) {
            event.stopPropagation();
            return false;
        });
    },

    /**
     * Reject All
     */
    _rejectAll: function () {
        let error = false;

        const rejectReasonField = $('textarea[name="reject_reason_text_all"].required');
        if (rejectReasonField.length > 0 && !rejectReasonField.val()) {
            error = true;
            rejectReasonField.addClass('error');
            abcsetup.alerts.show('Reject Error', 'Please provide a reject reason');
            return false;
        }

        $('#reject-btn').unbind('click').attr('type', 'submit').trigger('click');
    },

    /**
     * Reject the item
     */
    _rejectItem: function (item, event) {
        let error = false;
        event.stopPropagation();
        const rejectReasonField = $('textarea[name="reject_reason_text['+item+']"].required');
        if (rejectReasonField.length > 0 && !rejectReasonField.val()) {
            error = true;
            rejectReasonField.addClass('error');
            abcsetup.alerts.show('Reject Error', 'Please provide a reject reason');
            return false;
        }

        $("div.card-header[data-item='"+item+"']").find(".dropdown-toggle").dropdown('toggle');
        var task = $("#CurrentTaskId").val();

        axios.post('/api/three_pm_import/reject_item/' + item, {task: task, reject_reason: rejectReasonField.val()}).then(response => {
            // show message item approved
            if ( response.data.item ) {
                if ( response.data.message_type == "danger" ) {
                    // reject message is shown in a danger message
                    $("div.card-header[data-item='"+response.data.item+"']").closest('.card').animate({right: '110%'},500,'linear',function(){
                        abcsetup.alerts.flashMessage((response.data.message_text ? response.data.message_text : 'Error') + ' (' + (response.data.item ? response.data.item : 'NaN') + ')', (response.data.message_type ? response.data.message_type : 'warning'), false);
                        $(this).remove();
                    });
                } else {
                    abcsetup.alerts.flashMessage((response.data.message_text ? response.data.message_text : 'Error') + ' (' + (response.data.item ? response.data.item : 'NaN') + ')', (response.data.message_type ? response.data.message_type : 'warning'), false);
                }
            } else {
                abcsetup.alerts.flashMessage('An Unknown Error Occurred', 'warning', false);
            }
         });
    },

    /**
     * Approve the item
     */
    _approveItem: function (item) {
        // abcsetup.alerts.show('Approving', 'Item: '+item);
        var task = $("#CurrentTaskId").val();
        console.log('Approving', 'Item: ' + item + ', Task: ' + task);
        axios.post('/api/three_pm_import/approve_item/' + item, {task: task}).then(response => {
           // show message item approved
            if ( response.data.item ) {
                if ( response.data.message_type == "success" ) {
                    // approve message is shown in a success message
                    $("div.card-header[data-item='"+response.data.item+"']").closest('.card').animate({right: '110%'},500,'linear',function(){
                        abcsetup.alerts.flashMessage((response.data.message_text ? response.data.message_text : 'Error') + ' (' + (response.data.item ? response.data.item : 'NaN') + ')', (response.data.message_type ? response.data.message_type : 'warning'), false);
                        $(this).remove();
                    });
                } else {
                    abcsetup.alerts.flashMessage((response.data.message_text ? response.data.message_text : 'Error') + ' (' + (response.data.item ? response.data.item : 'NaN') + ')', (response.data.message_type ? response.data.message_type : 'warning'), false);
                }
            } else {
                abcsetup.alerts.flashMessage('An Unknown Error Occurred', 'warning', false);
            }
        });
    },

    /**
     * Submit the item
     */
    _submitItem: function (item) {
        // abcsetup.alerts.show('Approving', 'Item: '+item);
        var task = $("#CurrentTaskId").val();
        console.log('Submitting', 'Item: ' + item + ', Task: ' + task);
        axios.post('/api/three_pm_import/submit_item/' + item, {task: task}).then(response => {
           // show message item submitted
            if ( response.data.item ) {
                if ( response.data.message_type == "success" ) {
                    // submit message is shown in a success message
                    $("div.card-header[data-item='"+response.data.item+"']").closest('.card').animate({right: '110%'},500,'linear',function(){
                        abcsetup.alerts.flashMessage((response.data.message_text ? response.data.message_text : 'Error') + ' (' + (response.data.item ? response.data.item : 'NaN') + ')', (response.data.message_type ? response.data.message_type : 'warning'), false);
                        $(this).remove();
                    });
                } else {
                    abcsetup.alerts.flashMessage((response.data.message_text ? response.data.message_text : 'Error') + ' (' + (response.data.item ? response.data.item : 'NaN') + ')', (response.data.message_type ? response.data.message_type : 'warning'), false);
                }
            } else {
                abcsetup.alerts.flashMessage('An Unknown Error Occurred', 'warning', false);
            }
        });
    },

    /**
     * Remove the item
     */
     _removeItem: function (item) {
        // abcsetup.alerts.show('Approving', 'Item: '+item);
        var task = $("#CurrentTaskId").val();
        console.log('Removing', 'Item: ' + item + ', Task: ' + task);
        axios.post('/api/three_pm_import/remove_item/' + item, {task: task}).then(response => {
           // show message item removed
            if ( response.data.item ) {
                if ( response.data.message_type == "danger" ) {
                    // remove message is shown in a danger message
                    $("div.card-header[data-item='"+response.data.item+"']").closest('.card').animate({right: '110%'},500,'linear',function(){
                        abcsetup.alerts.flashMessage((response.data.message_text ? response.data.message_text : 'Error') + ' (' + (response.data.item ? response.data.item : 'NaN') + ')', (response.data.message_type ? response.data.message_type : 'warning'), false);
                        $(this).remove();
                    });
                } else {
                    abcsetup.alerts.flashMessage((response.data.message_text ? response.data.message_text : 'Error') + ' (' + (response.data.item ? response.data.item : 'NaN') + ')', (response.data.message_type ? response.data.message_type : 'warning'), false);
                }
            } else {
                abcsetup.alerts.flashMessage('An Unknown Error Occurred', 'warning', false);
            }
        });
    },

    // /**
    //  * Export all the items
    //  */
    // _export: function (item) {
    //     // abcsetup.alerts.show('Approving', 'Item: '+item);
    //     var import_id = $("#import_id").val();
    //     console.log('Exporting', 'Import ID: ' + import_id);
    //     axios.post('/api/three_pm_import/export/' + import_id).then(response => {
    //         if ( response.data ) {

    //         } else {

    //         }
    //     });
    // },
}
